export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_LIVING_ARRANGEMENT":
      return [...state, action.payload.livingArrangementHistory];
    case "UPDATE_LIVING_ARRANGEMENTS":
      return action.payload.livingArrangements;
    case "DELETE_LIVING_ARRANGEMENT":
      return state.filter((livingArrangementHistory) => {
        return livingArrangementHistory.id !== action.payload.livingArrangement.id
      });
    default:
      return state;
  }
}
